import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import SideBar from "../components/SideBar";
import SideBar2 from "../components/SideBar2";
import ContentWithBack from "../components/BotaoVoltar/ContentWithBack";
import MapaInova from "../pages/Maps&Actions/index";
import "./layout.scss";

export default function WithSideBarLayout() {




  
  const location = useLocation();

  const isBlurActive = location.pathname !== "/maps";

  //  BLOQUEIA SCROLL DO FUNDO
  useEffect(() => {
    if (isBlurActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isBlurActive]);

  return (
    <>
      {/*  FUNDO (MAPA + SIDEBAR) */}
      <div
        style={{
          filter: isBlurActive ? "blur(0px) brightness(0.7)" : "none",
          transition: "0.3s ease",

          //  bloqueia clique
          pointerEvents: isBlurActive ? "none" : "auto",
          //  opcional (deixa mais “desativado” visualmente)
          opacity: isBlurActive ? 0.4 : 1
        }}
      >
        {/* <SideBar2 /> */}
      <SideBar extraClass="sidebar-edit" isBlocked={isBlurActive} />
         {/* <MapaInova />  */}
      </div>

      {/*  TELA EM FOCO */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 10,

          //  evita scroll aqui também
          overflow: "auto"
        }}
      >
    
        <Outlet />
      </div>
    </>
  );
}